import { render, staticRenderFns } from "./CurrentZipRow.vue?vue&type=template&id=1fd0e21e&scoped=true&"
import script from "./CurrentZipRow.vue?vue&type=script&lang=js&"
export * from "./CurrentZipRow.vue?vue&type=script&lang=js&"
import style0 from "./CurrentZipRow.vue?vue&type=style&index=0&id=1fd0e21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd0e21e",
  null
  
)

export default component.exports